import { BaseClientService, Error, Result } from "../BaseClientService";

export class FrontCorphurusatoCalcService extends BaseClientService {
  url: string;

  constructor() {
    super();
    this.url = this.API_BASE_URL + "/api/front/lp/corphurusato_page/calculate";
  }

  async corphurusatoTax(input: CorphurusatoCalculateInput): Promise<Result<CorphurusatoCalculateOutput, Error>> {
    return super.doPost(this.url, JSON.stringify(input));
  }
}

interface CorphurusatoCalculateInput {
  所得: number;
  資本金: number;
  寄付金: number | null;
}

interface CorphurusatoCalculateOutput {
  寄付額: number;
  自己負担額: number;
  自己負担割合: number;
  損金算入効果: number;
  "税額控除①": number;
  住民税: number;
  法人税: number;
  地方法人税: number;
  法人事業税: number;
  法人税の2割: number;
  寄付額の4割: number;
  "上記のいずれか最小金額①": number;
  法人税の5: number;
  寄付額4割補填: number;
  寄付額の1割: number;
  "上記のいずれか最小金額②": number;
  事業税の2割: number;
  寄付金額の2割: number;
  "上記のいずれか最小金額③": number;
  "税額控除②": number;
}
